<template>
  <div>
    <div class="settings">
      <div class="title">用电脑设置</div>
      <div class="desc">
        <p v-if="isMobile || !isInApp">复制网址在浏览器打开官网</p>
        <p @click="!isMobile && isInApp ? goWeb() : ''">
          {{ !isMobile && isInApp ? "点击进入官网：" : "官网网址：" }}
          <span :class="!isMobile && isInApp ? 'pointerLink' : 'themeColor'"
            >xiaoxiaodati.com</span
          >
        </p>
      </div>
      <button
        class="copyBtn"
        v-clipboard:copy="copyText"
        v-clipboard:success="copySuccess"
      >
        一键复制网址
      </button>
      <div class="title">用手机设置</div>
      <div class="desc">
        {{
          isMobile ? "点击下方按钮" : "微信扫描下方答题二维码"
        }}，进入小程序
      </div>
      <div class="flexCenter">
        <div v-if="isMobile" class="position-r">
          <button class="copyBtn mt30" @click="toWx()">
            前往小程序
          </button>
          <WxLink v-if="isWeixin" wxPath="/pages/index/index" />
        </div>

        <img v-else class="qrocde" :src="src" alt="" />
      </div>
    </div>
    <div class="questions">
      <div class="title flexCenterBetween">
        <div class="l">常见问题</div>
      </div>
      <div class="list">
        <p
          v-for="item in lists"
          :key="item.title"
          class="list-item"
          @click="toDetail(item.path)"
        >
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220309/b3edec47e892740105b9578e1d587a8f.svg"
            alt=""
          />{{ item.title }}
        </p>
      </div>
    </div>
    <Contact />
  </div>
</template>
<script>
import Contact from "@/components/contact";
import WxLink from "@/components/wxLink.vue";
import { Toast } from "vant";
import { isMobile, getWxUrl, getDetailWxCode, goWebWay, isWeixin } from "@/utils/common";

export default {
  data() {
    return {
      isInApp: wemeet.app.isTMWebview(),
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      lists: [
        {
          title: "如何创建答题",
          path: "https://mp.weixin.qq.com/s/SEvru9C7PuIKVufxUQbD4Q"
        },
        {
          title: "如何设置答题规则",
          path: "https://mp.weixin.qq.com/s/r4aBcU6iiSrfl4abVhO6mg"
        },
        {
          title: "查看/下载答题记录",
          path: "https://mp.weixin.qq.com/s/x3cv66_6mrcIJAMx1hrnyw"
        },
        {
          title: "了解更多答题数据",
          path: "https://mp.weixin.qq.com/s/NCB2tp4K6lVjLNVHnerVug"
        }
      ],
      copyText: "https://xiaoxiaodati.com",
      src:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png"
    };
  },
  methods: {
    goWeb() {
      goWebWay();
    },
    toDetail(path) {
      window.location.href = path;
    },
    async toWx() {
      let url = this.qid
        ? await getWxUrl("pages/detail/detail", this.qid)
        : await getWxUrl();
      if (url) window.location.href = url;
    },
    copySuccess() {
      Toast("复制成功");
    }
  },
  async mounted() {
    this.qid = this.$route.query.qid || "";
    if (!this.isMobile && this.qid) {
      // pc端生成
      let res = await getDetailWxCode(this.qid);
      if (res) this.src = res;
    }
  },
  components: { Contact, WxLink }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.questions,
.settings {
  background: #fff;
  border-radius: rem(8);
  padding: rem(30);
  margin: rem(20) rem(30) 0;
  font-size: rem(28);
}
.title {
  font-size: rem(34);
  line-height: rem(51);
  margin-bottom: rem(20);
  .r {
    font-size: rem(28);
    color: #999;
  }
}
.desc {
  line-height: rem(42);
}
.list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: rem(10);
  .list-item {
    width: 50%;
    line-height: rem(42);
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: #1890ff;
    }
    img {
      width: rem(14);
      height: rem(21);
      margin-right: rem(16);
    }
  }
  .list-item:nth-child(1),
  .list-item:nth-child(2) {
    margin-bottom: rem(20);
  }
}
.copyBtn {
  color: #fff;
  background: #1890ff;
  padding: rem(11) rem(30);
  border-radius: rem(8);
  margin: rem(10) 0 rem(40);
  cursor: pointer;
}
.copyBtn.mt30 {
  margin-top: rem(60);
}

.qrocde {
  margin: rem(30) auto rem(50);
  width: rem(350);
}
</style>



// WEBPACK FOOTER //
// src/pages/helpCenter/helpCenter.vue